import React, { memo, Fragment } from "react";
import { useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import * as SettingSelector from "../../../../../store/setting/selectors";
import useRedirect from "../../../../../components/custom-hooks/use-redirect";
import Sidebarlogo from "../../../../../components/partials/components/sidebar/sidebar-logo";
import { useGetProjectDetails } from "../../../../../queries/query-hooks/workspace/workspace-hook";
import SidebarProfileCard from "../../../../../components/partials/components/sidebar/sidebar-profile-card";
import EmslVerticalNav from "./EmslVerticalNav";

const EmslSidebar = memo(() => {
  const { redirectTo } = useRedirect();
  const { project_id, page_title } = useParams();

  const { data: projectDetails, isLoading: isProjectDetailsLoading } =
    useGetProjectDetails(project_id);

  const appName = useSelector(SettingSelector.app_name);
  const sidebarColor = useSelector(SettingSelector.sidebar_color);
  const sidebarHide = useSelector(SettingSelector.sidebar_show);
  const sidebarType = useSelector(SettingSelector.sidebar_type);
  const sidebarMenuStyle = useSelector(SettingSelector.sidebar_menu_style);

  const onBackButtonClick = () => {
    if (page_title) {
      if (page_title === "interactions") {
        redirectTo(`emsl/summary/interactions/${project_id}`);
      } else if (page_title === "consented_leads") {
        redirectTo(`emsl/summary/consented-leads/${project_id}`);
      } else {
        redirectTo("workspace/clirnet");
      }
    } else {
      redirectTo("workspace/clirnet");
    }
  };

  const pageTitle =
    page_title === "interactions"
      ? "Interactions"
      : page_title === "consented_leads"
      ? "Consented Leads"
      : "Projects";

  return (
    <Fragment>
      <aside
        className={`${sidebarColor} ${sidebarType.join(
          " "
        )} ${sidebarMenuStyle} ${
          sidebarHide.join(" ") ? "sidebar-none" : "sidebar"
        } sidebar-base `}
      >
        <Sidebarlogo app_name={appName} />

        <div className="sidebar-body pt-0 data-scrollbar" id="my-scrollbar">
          {
            <SidebarProfileCard
              title={
                projectDetails && projectDetails?.length > 0
                  ? projectDetails[0]?.project_name
                  : ""
              }
              logo={
                projectDetails && projectDetails?.length > 0
                  ? projectDetails[0]?.project_logo
                  : ""
              }
              isLoading={isProjectDetailsLoading}
              previousPageName={pageTitle}
              onBackButtonClick={onBackButtonClick}
            />
          }

          <hr className="hr-horizontal" />
          <div className="sidebar-list">
            <EmslVerticalNav />
          </div>
        </div>
        <div className="sidebar-footer"></div>
      </aside>
    </Fragment>
  );
});

export default EmslSidebar;
